import React, { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

const Profile = () => {
  const auth = useContext(AuthContext);
  
  return (
    <div>
      <h2>User Profile</h2>
      <div className="card mt-4">
        <div className="card-body">
          <h5 className="card-title">Profile Information</h5>
          <p><strong>Username:</strong> {auth.user?.username}</p>
          <p><strong>Name:</strong> {auth.user?.full_name || 'Not provided'}</p>
          <p><strong>Email:</strong> {auth.user?.email || 'Not provided'}</p>
          <p><strong>Permissions:</strong> {auth.user?.permissions?.join(', ') || 'None'}</p>
        </div>
      </div>
    </div>
  );
};

export default Profile;
